// The microphone/speech banner, shared by the chat and practice screens.
//
// When the app is running inside someone else's page the microphone is blocked
// by permission policy and there is nothing the app can do about it from the
// inside, so the banner offers the one thing that does work: opening the app in
// its own tab.
import { useStore } from '../store';

export default function SpeechNotice() {
  const s = useStore();
  if (!s.speechMessage) return null;

  return (
    <div className="notice">
      <span>{s.speechMessage}</span>
      {s.embedded && (
        <a
          className="notice-link"
          href={window.location.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open in a new tab ↗
        </a>
      )}
      <button
        type="button"
        className="notice-dismiss"
        onClick={s.dismissSpeechMessage}
        aria-label="Dismiss this message"
      >
        ✕
      </button>
    </div>
  );
}
